/* eslint-disable react/prop-types */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  List,
  Switch,
  Typography,
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { isEqual } from "lodash"
import React, { useState } from "react"

import FilterItem from "./FilterItem"
import useStyles from "./styles"

const FiltersDialog = ({ onClose, open, filters, filterType }) => {
  const classes = useStyles()

  const [localFilterType, setLocalFilterType] = useState(filterType)
  const [localFilters, setLocalFilters] = useState([...filters])

  const handleFilterItemClicked = (filter) => {
    setLocalFilters(
      localFilters.map((f) => {
        if (isEqual(f.filter, filter)) {
          f = {
            ...f,
            checked: !f.checked,
          }
        }
        return f
      }),
    )
  }
  const handleClose = () => {
    onClose(localFilters, localFilterType ? "AND" : "OR")
  }
  const handleFilterTypeChanged = (e) => {
    const checked = e.target.checked
    setLocalFilterType(checked)
  }

  const handleClearFilters = () => {
    setLocalFilters(
      localFilters.map((f) => {
        f.checked = false
        return f
      }),
    )
    setLocalFilterType("AND")
    handleClose()
  }

  const handleDialogEntering = () => {
    setLocalFilters([...filters])
    setLocalFilterType(filterType)
  }

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      TransitionProps={{ onEntering: handleDialogEntering }}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h6">Apply Filters</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <List>
          {localFilters.map((filter) => (
            <FilterItem
              key={filter.label}
              filter={filter}
              onClick={handleFilterItemClicked}
            />
          ))}
        </List>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(localFilterType === "AND")}
              onChange={handleFilterTypeChanged}
              name="match-all"
              inputProps={{ "aria-label": "secondary checkbox" }}
            />
          }
          label="Match All"
        />
        <div className={classes.dialogButtons}>
          <Button color="secondary" onClick={handleClearFilters}>
            Clear Filters
          </Button>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default FiltersDialog
